import React, { useEffect, useMemo, useRef } from 'react';
import { MediaTypes } from '../../commands/practitioner/enums/MediaTypes';
import ReactPlayer from 'react-player/lazy';
import usePractitionerControlsContext from '../../hooks/usePractitionerControlsContext/usePractitionerControlsContext';
import { ReactPlayerProps } from 'react-player';
import useClientMediaState from '../../hooks/useClientMediaState/useClientMediaState';
import { PLayerTriggeredBy } from '../../commands/practitioner/enums/PLayerTriggeredBy';

interface DialogMediaPlayerProps {
  ReactPlayerProps: ReactPlayerProps;
  ReactPlayerTriggeredBy: PLayerTriggeredBy;
  handleMediaEnd?: any;
}

function DialogMediaPlayer(props: DialogMediaPlayerProps) {
  const { ReactPlayerProps, handleMediaEnd } = props;
  const { practitionerMediaType, practitionerMediaURI } = usePractitionerControlsContext();
  const { isClientReactPLayerStarted, clientMediaURI, clientMediaType } = useClientMediaState();

  const playerRef = useRef(null);

  useEffect(() => {
    if (!playerRef.current) {
      return;
    }
    // @ts-ignore
    playerRef.current.seekTo(0);
  }, [clientMediaURI]);

  const RenderType = useMemo(() => {
    switch (props.ReactPlayerTriggeredBy === PLayerTriggeredBy.Practitioner ? practitionerMediaType : clientMediaType) {
      case MediaTypes.VIDEO:
        return (
          <ReactPlayer
            className="react-player"
            width="100%"
            height="100%"
            ref={playerRef}
            {...ReactPlayerProps}
            onEnded={handleMediaEnd}
            config={{
              youtube: {
                playerVars: { showinfo: 1, disableAds: true },
              },
            }}
          />
        );
      case MediaTypes.AUDIO:
        return (
          <ReactPlayer ref={playerRef} style={{ display: 'none' }} {...ReactPlayerProps} onEnded={handleMediaEnd} />
        );
      case MediaTypes.IMAGE:
        return (
          <img
            src={props.ReactPlayerTriggeredBy === PLayerTriggeredBy.Client ? clientMediaURI : practitionerMediaURI}
            style={{ aspectRatio: 'auto' }}
          />
        );
      default:
        return <ReactPlayer />;
    }
  }, [
    practitionerMediaType,
    clientMediaURI,
    ReactPlayerProps,
    practitionerMediaURI,
    isClientReactPLayerStarted,
    clientMediaType,
  ]);

  return <>{RenderType}</>;
}

export default DialogMediaPlayer;
